export enum Languages {
  en = "en-us",
  es = "es-mx",
  pt = "pt-pt",
  hat = "ht-ht"
}
